// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"SI-z","smallCardRow":"TI-z","largeCardRow":"UI-z","productSearchRow":"VI-z","curatedRow":"WI-z"};